import $ from 'jquery';

let GA;

function absoluteUrl(url) {
  if (url.indexOf('http') === 0) {
    return url;
  }
  const baseurl = window.location.origin || window.location.host;
  const base = baseurl.replace(/\/$/, '');
  const path = url.replace(/^\//, '');
  return [base, path].join('/');
}

function getShareURI(shareUrl, title, service, tags) {
  const shareServices = {
    twitter: `https://twitter.com/share?url=${ shareUrl }&text=${ title }${ tags ? `&hashtags=${ tags }` : '' }`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${ shareUrl }`,
    gplus: `https://plus.google.com/share?url=${ shareUrl }`,
    linkedin: `https://www.linkedin.com/shareArticle?url=${ shareUrl }&title=${ title }&source=${ window.location.href }&mini=true`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${ window.location.href }&media=${ shareUrl }&description=${ title }`,
  };
  return encodeURI(shareServices[service]);
}

function handleClick(e) {
  const button = $(this);

  const url = absoluteUrl(button.attr('data-share-url'));
  const title = button.attr('data-share-title');
  const service = button.attr('data-share-service');
  const tags = button.attr('data-share-tags');

  const windowFeatures = `height=350,width=650,left=${ e.screenX - 325 },top=300`;
  const uri = getShareURI(url, title, service, tags);

  window.open(uri, 'Share', windowFeatures);

  GA.track(`${ title } - ${ url }`, 'Share Widget', `Share on ${ service }`);
}


function init(conf) {
  GA = GA || conf.GA;
  $('.share-widget__button').on('click', handleClick);
}

export default { init };
